import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { BrandedLayout } from "./components/BrandedLayout";
import { CheckoutPage } from "./pages/CheckoutPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ReturnPage } from "./pages/ReturnPage";
import { theme } from "./theme";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <BrandedLayout>
          <Routes>
            <Route path="/c/:publicToken" element={<CheckoutPage />} />
            <Route path="/c/:publicToken/return" element={<ReturnPage />} />
            <Route path="/" element={<Navigate to="/404" replace />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrandedLayout>
      </BrowserRouter>
    </ThemeProvider>
  );
}
